export const getScmToPathBase = () => {
    return {
        scmUrlBasic: '/scm-inquiry',
        scmUrlContract: '/scm-contract',
        scmUrlSettle: '/scm-settle',
        scmUrlOrder: '/scm-order',
        scmUrlBill: '/scm-bill',
        scmUrlInvoice: '/scm-settle-invoice',
        scmUrlPnm2: '/scm-settle-finance',
        scmBasic: '/scm-basic',
    };
};
export const getScmToPathName = (t = {}, base = {}) => {
    base = {
        ...getScmToPathBase(),
        ...base,
    };
    const businessCode = t.businessCode || t.busCode || '';
    const variables = {
        ...(t.variables || {}),
    };
    let userInfo = JSON.parse(sessionStorage.getItem('USER_INFO') || '{}');
    const getCompanyId = () => {
        return userInfo.defaultCompId || '';
    };
    if (businessCode == 'scm3050') {
        return (base.scmUrlOrder + `/purOrder/receive/detail?closeId=${t.businessKey}`);
    }
    if (businessCode == 'scm3040') {
        return (base.scmUrlOrder + `/supOrder/saleReturn/detail?closeId=${t.businessKey}`);
    }
    if (businessCode == 'scm3091') {
    }
    if (businessCode == 'scm3031') {
        if (variables.type == 1) {
            if (variables.contractCompanyId != getCompanyId()) {
                return (base.scmUrlSettle +
                    `/pur_bill/accept/handle/detail?closeId=${t.businessKey}`);
            }
            return (base.scmUrlSettle +
                `/pur_bill/settlement/receivable/detail?closeId=${t.businessKey}`);
        }
        else {
            if (variables.contractCompanyId != getCompanyId()) {
                return (base.scmUrlSettle +
                    `/sup_bill/accept/receivable/detail?closeId=${t.businessKey}`);
            }
            return (base.scmUrlSettle +
                `/sup_bill/settlement/handle/detail?closeId=${t.businessKey}`);
        }
    }
    if (businessCode == 'scm3030') {
        if (variables.contractCompanyId != getCompanyId()) {
            return (base.scmUrlOrder + `/purOrder/return/detail?closeId=${t.businessKey}`);
        }
        return (base.scmUrlOrder +
            `/supOrder/purchaseReturn/detail?closeId=${t.businessKey}`);
    }
    if (businessCode == 'scm3061') {
        if (variables.contractCompanyId == getCompanyId()) {
            if (variables.type == 1) {
                return (base.scmUrlOrder +
                    `/purOrder/pur-transfer-property/detail?closeId=${t.businessKey}`);
            }
            return (base.scmUrlOrder +
                `/supOrder/sup-transfer-property/detail?closeId=${t.businessKey}`);
        }
        else {
            if (variables.type == 1) {
                return (base.scmUrlOrder +
                    `/supOrder/sup-transfer-property-receive/detail?closeId=${t.businessKey}`);
            }
            return (base.scmUrlOrder +
                `/purOrder/pur-transfer-property-receive?closeId=${t.businessKey}`);
        }
    }
    if (businessCode == 'scm3041') {
        if (variables.contractCompanyId == getCompanyId()) {
            return base.scmUrlBill + `/initiate/detail?closeId=${t.businessKey}`;
        }
        return base.scmUrlBill + `/confirm/detail?closeId=${t.businessKey}`;
    }
    if (businessCode == 'scm3080') {
        return (base.scmUrlPnm2 +
            `/pur-capital-flow/pay-apply/-detail?closeId=${t.businessKey}`);
    }
    if (businessCode == 'scm3090') {
        return (base.scmUrlInvoice + `/sup-invoice/apply/detail?closeId=${t.businessKey}`);
    }
    if (businessCode == 'scm3091') {
        // type : 1 表示 发起进项 或 接收购货方
        // type : 2 表示 发起销项 或 接收供应商
        // companyId 相等即 发起
        // companyId 不相等即 接收
        // 0表示公司不相等 1表示公司相等
        const isSame = variables.contractCompanyId == getCompanyId();
        const urlMap = isSame
            ? {
                1: '/pur-invoice/income/-detail',
                2: '/sup-invoice/output/-detail',
            }
            : {
                1: '/sup-invoice/buyer/-detail',
                2: '/pur-invoice/suppilier/-detail',
            };
        const url = urlMap?.[variables.type];
        if (url) {
            return base.scmUrlInvoice + `${url}?closeId=${t.businessKey}`;
        }
    }
    if (businessCode == 'scm3081') {
        if (variables.contractCompanyId == getCompanyId()) {
            return (base.scmUrlPnm2 +
                `/pur-capital-flow/pay/-detail?closeId=${t.businessKey}`);
        }
        return (base.scmUrlPnm2 +
            `/sup-capital-flow/income/-detail?closeId=${t.businessKey}`);
    }
    //供货方
    if (variables && variables.type && variables.type === 2) {
        switch (businessCode) {
            case 'scm3010': {
                // if(!variables.contractCompanyId||variables.contractCompanyId==getCompanyId()){
                // }else{
                // }
                if (variables.companyId == getCompanyId()) {
                    if (variables.contractCompanyId != getCompanyId()) {
                        return (base.scmUrlContract +
                            `/purContract/purQutContract/${variables.busType == 2
                                ? 'close'
                                : variables.busType == 1
                                    ? 'cancel'
                                    : 'cancelClose'}/detail?id=` +
                            t.businessKey +
                            '&busType=' +
                            variables.busType);
                    }
                    return (base.scmUrlContract +
                        `/supContract/contract/${variables.busType == 2
                            ? 'close'
                            : variables.busType == 1
                                ? 'cancel'
                                : 'cancelClose'}/detail?id=` +
                        t.businessKey +
                        '&busType=' +
                        variables.busType);
                }
                else {
                    // 关闭单据不是我创的,但是合同是我创的
                    if (variables.contractCompanyId == getCompanyId()) {
                        return (base.scmUrlContract +
                            `/supContract/contract/${variables.busType == 2
                                ? 'close'
                                : variables.busType == 1
                                    ? 'cancel'
                                    : 'cancelClose'}/detail?id=` +
                            t.businessKey +
                            '&busType=' +
                            variables.busType);
                    }
                    return (base.scmUrlContract +
                        `/purContract/purQutContract/${variables.busType == 2
                            ? 'close'
                            : variables.busType == 1
                                ? 'cancel'
                                : 'cancelClose'}/detail?id=` +
                        t.businessKey +
                        '&busType=' +
                        variables.busType);
                }
            }
            case 'scm3021': {
                if (variables.contractCompanyId != getCompanyId()) {
                    return (base.scmUrlOrder +
                        `/purOrder/shipmentsNotice/detail?closeId=` +
                        t.businessKey +
                        '&busType=' +
                        variables.busType);
                }
                else {
                    return (base.scmUrlOrder +
                        `/supOrder/shipmentsNotice/detail?closeId=` +
                        t.businessKey +
                        '&busType=' +
                        variables.busType);
                }
            }
            case 'scm3020': {
                if (variables.contractCompanyId != getCompanyId()) {
                    return (base.scmUrlOrder +
                        `/purOrder/shipments/detail?closeId=` +
                        t.businessKey +
                        '&busType=' +
                        variables.busType);
                }
                else {
                    return (base.scmUrlOrder +
                        `/supOrder/shipments/detail?closeId=` +
                        t.businessKey +
                        '&busType=' +
                        variables.busType);
                }
            }
            case 'scm3060': {
                if (variables.companyId == getCompanyId()) {
                    // if (variables.contractCompanyId != getCompanyId()) {
                    //   return (
                    //     base.scmUrlOrder +
                    //     `/purOrder/supOrder/detailEdit?closeId=` +
                    //     t.businessKey +
                    //     '&busType=' +
                    //     variables.busType
                    //   );
                    // }
                    // return (
                    //   base.scmUrlOrder +
                    //   `/supOrder/orderTable/detail?closeId=` +
                    //   t.businessKey +
                    //   '&busType=' +
                    //   variables.busType
                    // );
                    if (variables?.type == 2) {
                        return (base.scmUrlOrder +
                            `/supOrder/orderTable/detail?closeId=` +
                            t.businessKey +
                            '&busType=' +
                            variables.busType);
                    }
                    else {
                        return (base.scmUrlOrder +
                            `/purOrder/orderTable/detail?closeId=` +
                            t.businessKey +
                            '&busType=' +
                            variables.busType);
                    }
                }
                else {
                    // 关闭单据不是我创的,但是合同是我创的
                    if (variables.contractCompanyId == getCompanyId()) {
                        return (base.scmUrlOrder +
                            `/purOrder/orderTable/detail?closeId=` +
                            t.businessKey +
                            '&busType=' +
                            variables.busType);
                    }
                    return (base.scmUrlOrder +
                        `/supOrder/orderTable/detail?closeId=` +
                        t.businessKey +
                        '&busType=' +
                        variables.busType);
                }
            }
            // 询价
            case 'scm1010':
                return (base.scmUrlBasic +
                    '/supplier/supplierInquiry/detail?id=' +
                    t.businessKey);
            case 'scm1030':
                return base.scmUrlBasic + '/supplier/subver/detail?id=' + t.businessKey;
            // 合同
            case 'scm1040':
                if (getCompanyId() == variables.companyId) {
                    // 销售合同
                    return (base.scmUrlContract +
                        '/supContract/contract/detail?id=' +
                        t.businessKey);
                }
                else {
                    // 确认采购合同
                    return (base.scmUrlContract +
                        '/purContract/purQutContract/detailEdit?id=' +
                        t.businessKey);
                }
            // 补充协议
            case 'scm1050':
                if (getCompanyId() == variables.companyId) {
                    return (base.scmUrlContract +
                        '/supContract/cusAgreeTable/detail?id=' +
                        t.businessKey);
                }
                else {
                    return (base.scmUrlContract +
                        '/purContract/confirm/agree/detail?id=' +
                        t.businessKey);
                }
            // 采购订单
            case 'scm1060':
                if (getCompanyId() == variables.companyId) {
                    return (base.scmUrlOrder + '/supOrder/orderTable/detail?id=' + t.businessKey);
                }
                else {
                    return (base.scmUrlOrder +
                        '/purOrder/supOrder/detailEdit?id=' +
                        t.businessKey);
                }
            // 订单变更
            case 'scm1070':
                if (getCompanyId() == variables.companyId) {
                    return (base.scmUrlOrder +
                        '/supOrder/orderChange/detail?id=' +
                        t.businessKey);
                }
                else {
                    return (base.scmUrlOrder +
                        '/purOrder/confirmOrderChange/detail?id=' +
                        t.businessKey);
                }
        }
    }
    else {
        // 采购方
        switch (businessCode) {
            case 'scm3010': {
                if (variables.companyId == getCompanyId()) {
                    // 关闭单据是我创的,但是合同也是我创的
                    if (variables.contractCompanyId != getCompanyId()) {
                        return (base.scmUrlContract +
                            `/supContract/supInqContract/${variables.busType == 2
                                ? 'close'
                                : variables.busType == 1
                                    ? 'cancel'
                                    : 'cancelClose'}/detail?id=` +
                            t.businessKey +
                            '&busType=' +
                            variables.busType);
                    }
                    return (base.scmUrlContract +
                        `/purContract/contract/${variables.busType == 2
                            ? 'close'
                            : variables.busType == 1
                                ? 'cancel'
                                : 'cancelClose'}/detail?id=` +
                        t.businessKey +
                        '&busType=' +
                        variables.busType);
                }
                else {
                    // 关闭单据不是我创的,但是合同是我创的
                    if (variables.contractCompanyId == getCompanyId()) {
                        return (base.scmUrlContract +
                            `/purContract/contract/${variables.busType == 2
                                ? 'close'
                                : variables.busType == 1
                                    ? 'cancel'
                                    : 'cancelClose'}/detail?id=` +
                            t.businessKey +
                            '&busType=' +
                            variables.busType);
                    }
                    return (base.scmUrlContract +
                        `/supContract/supInqContract/${variables.busType == 2
                            ? 'close'
                            : variables.busType == 1
                                ? 'cancel'
                                : 'cancelClose'}/detail?id=` +
                        t.businessKey +
                        '&busType=' +
                        variables.busType);
                }
            }
            case 'scm3021': {
                if (variables.contractCompanyId != getCompanyId()) {
                    return (base.scmUrlOrder +
                        `/purOrder/shipmentsNotice/detail?closeId=` +
                        t.businessKey +
                        '&busType=' +
                        variables.busType);
                }
                else {
                    return (base.scmUrlOrder +
                        `/supOrder/shipmentsNotice/detail?closeId=` +
                        t.businessKey +
                        '&busType=' +
                        variables.busType);
                }
            }
            case 'scm3020': {
                if (variables.contractCompanyId != getCompanyId()) {
                    return (base.scmUrlOrder +
                        `/purOrder/shipments/detail?closeId=` +
                        t.businessKey +
                        '&busType=' +
                        variables.busType);
                }
                else {
                    return (base.scmUrlOrder +
                        `/supOrder/shipments/detail?closeId=` +
                        t.businessKey +
                        '&busType=' +
                        variables.busType);
                }
            }
            case 'scm3060': {
                if (variables.companyId == getCompanyId()) {
                    // 关闭单据是我创的,但是合同不是我创的
                    if (variables.contractCompanyId != getCompanyId()) {
                        return (base.scmUrlOrder +
                            `/supOrder/purOrder/detailEdit?closeId=` +
                            t.businessKey +
                            '&busType=' +
                            variables.busType);
                    }
                    return (base.scmUrlOrder +
                        `/purOrder/orderTable/detail?closeId=` +
                        t.businessKey +
                        '&busType=' +
                        variables.busType);
                }
                else {
                    // 关闭单据不是我创的,但是合同是我创的
                    if (variables.contractCompanyId == getCompanyId()) {
                        return (base.scmUrlOrder +
                            `/purOrder/orderTable/detail?closeId=` +
                            t.businessKey +
                            '&busType=' +
                            variables.busType);
                    }
                    return (base.scmUrlOrder +
                        `/supOrder/purOrder/detailEdit?closeId=` +
                        t.businessKey +
                        '&busType=' +
                        variables.busType);
                }
            }
            // 询价
            case 'scm1010':
                return (base.scmUrlBasic + '/purchaser/inquiry/detail?id=' + t.businessKey);
            case 'scm1030':
                return (base.scmUrlBasic + '/purchaser/pubver/detail?id=' + t.businessKey);
            // 合同
            case 'scm1040':
                if (getCompanyId() == variables.companyId) {
                    return (base.scmUrlContract +
                        '/purContract/contract/detail?id=' +
                        t.businessKey);
                }
                else {
                    return (base.scmUrlContract +
                        '/supContract/supInqContract/detailEdit?id=' +
                        t.businessKey);
                }
            // 补充协议
            case 'scm1050':
                if (getCompanyId() == variables.companyId) {
                    return (base.scmUrlContract +
                        '/purContract/agreeTable/detail?id=' +
                        t.businessKey);
                }
                else {
                    return (base.scmUrlContract +
                        '/supContract/confirm/agree/detail?id=' +
                        t.businessKey);
                }
            // 采购订单
            case 'scm1060':
                if (getCompanyId() == variables.companyId) {
                    return (base.scmUrlOrder + '/purOrder/orderTable/detail?id=' + t.businessKey);
                }
                else {
                    return (base.scmUrlOrder +
                        '/supOrder/purOrder/detailEdit?id=' +
                        t.businessKey);
                }
            // 订单变更
            case 'scm1070':
                if (getCompanyId() == variables.companyId) {
                    return (base.scmUrlOrder +
                        '/purOrder/orderChange/detail?id=' +
                        t.businessKey);
                }
                else {
                    return (base.scmUrlOrder +
                        '/supOrder/confirmOrderChange/detail?id=' +
                        t.businessKey);
                }
        }
    }
    // 报价单
    if (businessCode === 'scm1020') {
        if (variables.companyId !== getCompanyId()) {
            // 接收方
            return (base.scmUrlBasic +
                '/purchaser/purchaserQuotation/detail?id=' +
                t.businessKey);
        }
        else {
            return (base.scmUrlBasic + '/supplier/quotation/detail?id=' + t.businessKey);
        }
    }
    // scm2030 的挪这里来
    if (businessCode === 'scm2030') {
        if (variables.type === 2) {
            // 销售
            if (variables.companyId !== getCompanyId()) {
                // 接收方
                return (base.scmUrlContract +
                    '/purContract/confirmSellerOperator/detail?id=' +
                    t.businessKey);
            }
            else {
                return (base.scmUrlContract +
                    '/supContract/changeSellerOperator/detail?id=' +
                    t.businessKey);
            }
        }
        else {
            // 采购
            if (variables.companyId !== getCompanyId()) {
                // 接收方
                return (base.scmUrlContract +
                    '/supContract/confirmPurchaserOperator/detail?id=' +
                    t.businessKey);
            }
            else {
                // 发起方
                return (base.scmUrlContract +
                    '/purContract/confirmPurchaserOperator/detail?id=' +
                    t.businessKey);
            }
        }
    }
    if (businessCode.startsWith('logistic')) {
        // 交易协同全部
        if (businessCode === 'logistic1040') {
            return (base.scmUrlOrder + '/supOrder/saleReturn/detail?id=' + t.businessKey);
        }
        // 物权转移
        if (businessCode === 'logistic1060') {
            if (variables.companyId !== getCompanyId()) {
                // 接收
                if (variables.type == 1) {
                    return (base.scmUrlOrder +
                        '/supOrder/sup-transfer-property-receive/detail?id=' +
                        t.businessKey);
                }
                else {
                    return (base.scmUrlOrder +
                        '/purOrder/pur-transfer-property-receive/detail?id=' +
                        t.businessKey);
                }
            }
            else {
                // 采购发起
                if (variables.type == 1) {
                    return (base.scmUrlOrder +
                        '/purOrder/pur-transfer-property/detail?id=' +
                        t.businessKey);
                }
                else {
                    // 销售发起
                    return (base.scmUrlOrder +
                        '/supOrder/sup-transfer-property/detail?id=' +
                        t.businessKey);
                }
            }
        }
        if (variables.companyId !== getCompanyId()) {
            // 接收方
            switch (businessCode) {
                // 客户退货
                case 'logistic1030':
                    return (base.scmUrlOrder +
                        '/supOrder/purchaseReturn/detail?id=' +
                        t.businessKey);
                // 到货单
                case 'logistic1020':
                    return (base.scmUrlOrder + '/purOrder/shipments/detail?id=' + t.businessKey);
                // 到货通知单
                case 'logistic1010':
                    return (base.scmUrlOrder +
                        '/purOrder/shipmentsNotice/detail?id=' +
                        t.businessKey);
            }
        }
        else {
            // 发起方
            switch (businessCode) {
                // 销售发货
                case 'logistic1020':
                    return (base.scmUrlOrder + '/supOrder/shipments/detail?id=' + t.businessKey);
                // 销售发货通知
                case 'logistic1010':
                    return (base.scmUrlOrder +
                        '/supOrder/shipmentsNotice/detail?id=' +
                        t.businessKey);
                // 采购退货
                case 'logistic1030':
                    return (base.scmUrlOrder + '/purOrder/return/detail?id=' + t.businessKey);
                // 采购收货
                case 'logistic1050':
                    return (base.scmUrlOrder + '/purOrder/receive/detail?id=' + t.businessKey);
            }
        }
    }
    // 结算系统(杨哥的)
    if (businessCode.startsWith('settle')) {
        // 叫 pnm 写这里面
        if (businessCode === 'settle1010') {
            const toUrl = userInfo.defaultCompId == variables.companyId
                ? '/pur-capital-flow/pay/-detail'
                : '/sup-capital-flow/income/-detail';
            return base.scmUrlPnm2 + `${toUrl}?id=${t.businessKey}`;
        }
        else if (businessCode === 'settle1060') {
            if (variables.type && variables.type == 2) {
                const toUrl = userInfo.defaultCompId == variables.companyId
                    ? '/sup-invoice/output/-detail'
                    : '/pur-invoice/suppilier/-detail';
                return base.scmUrlInvoice + `${toUrl}?id=${t.businessKey}`;
            }
            else {
                const toUrl = userInfo.defaultCompId == variables.companyId
                    ? '/pur-invoice/income/-detail'
                    : '/sup-invoice/buyer/-detail';
                return base.scmUrlInvoice + `${toUrl}?id=${t.businessKey}`;
            }
        }
        else if (businessCode === 'settle1030') {
            const urlName = variables.settleType == 2 ? 'handle' : 'receivable';
            const urlPre = variables.settleType === 1 ? 'pur_bill' : 'sup_bill';
            const userInfoJson = JSON.parse(sessionStorage.getItem('USER_INFO') || '{}');
            if (userInfoJson && userInfoJson.defaultCompId === variables.companyId) {
                return (base.scmUrlSettle +
                    `/${urlPre}/settlement/${urlName}/detail?id=${t.businessKey}&type=${variables.type || 1}`);
            }
            else {
                return (base.scmUrlSettle +
                    `/${variables.settleType === 2 ? 'pur_bill' : 'sup_bill'}/accept/${urlName}/detail?id=${t.businessKey}`);
            }
        }
        else if (businessCode === 'settle1040') {
            const userInfoJson = userInfo;
            if (userInfoJson && userInfoJson.defaultCompId === variables.companyId) {
                return base.scmUrlBill + `/initiate/detail?id=${t.businessKey}`;
            }
            else {
                return base.scmUrlBill + `/confirm/detail?id=${t.businessKey}`;
            }
        }
        else if (businessCode === 'settle1050') {
            const urlName = variables?.type == 2 ? 'handle' : 'receivable';
            const urlPre = variables?.type == 1 ? 'pur_bill' : 'sup_bill';
            return (base.scmUrlSettle +
                `/${urlPre}/writeoff/${urlName}/detail?id=${t.businessKey}`);
        }
        else if (businessCode === 'settle1080') {
            const userInfoJson = JSON.parse(sessionStorage.getItem('USER_INFO') || '{}');
            if (userInfoJson && userInfoJson.defaultCompId === variables.companyId) {
                return (base.scmUrlSettle +
                    `/sup_bill/extend-apply/detail?id=${t.businessKey}`);
            }
            else {
                return (base.scmUrlSettle +
                    `/pur_bill/extend-apply/accept/detail?id=${t.businessKey}`);
            }
        }
    }
    // 尽职调查
    if (businessCode == 'scm2050') {
        const map = {
            1: '/diligence/initiate/-detail?id=',
            2: '/diligence/accepts/-detail?id=',
            3: '/diligence/upload-material/-detail?id=',
        };
        if (map?.[variables.type]) {
            return base.scmBasic + map?.[variables.type] + t.businessKey;
        }
    }
    // 付款申请
    if (businessCode == 'settle1090') {
        return `${base.scmUrlPnm2}/pur-capital-flow/pay-apply/-detail?id=${t.businessKey}`;
    }
    // 开票申请
    if (businessCode == 'settle2010') {
        return `${base.scmUrlInvoice}/sup-invoice/apply/detail?id=${t.businessKey}`;
    }
    return ``;
};
/**
 * 返回scm的业务map
 * @param row 接口返回的参数 { businessCode:'' ,  variables:{ } }
 * @param customProps 预留字段：各个业务自己需要的特殊参数
 * @returns String
 */
export const scmToPathNameMap = (function () {
    return {
        scm1010: getScmToPathName,
        scm1020: getScmToPathName,
        scm1030: getScmToPathName,
        scm1040: getScmToPathName,
        scm1050: getScmToPathName,
        scm1060: getScmToPathName,
        scm1070: getScmToPathName,
        scm2030: getScmToPathName,
        scm3010: getScmToPathName,
        scm3060: getScmToPathName,
        scm3061: getScmToPathName,
        scm3020: getScmToPathName,
        scm3021: getScmToPathName,
        scm3050: getScmToPathName,
        scm3051: getScmToPathName,
        scm3030: getScmToPathName,
        scm3031: getScmToPathName,
        scm3041: getScmToPathName,
        scm3081: getScmToPathName,
        scm3080: getScmToPathName,
        scm3090: getScmToPathName,
        scm3091: getScmToPathName,
        scm2050: getScmToPathName,
        logistic1010: getScmToPathName,
        logistic1020: getScmToPathName,
        logistic1030: getScmToPathName,
        logistic1040: getScmToPathName,
        logistic1050: getScmToPathName,
        logistic1060: getScmToPathName,
        settle1010: getScmToPathName,
        settle1030: getScmToPathName,
        settle1040: getScmToPathName,
        settle1050: getScmToPathName,
        settle1060: getScmToPathName,
        settle1080: getScmToPathName,
        settle1090: getScmToPathName,
        settle2010: getScmToPathName,
    };
})();
export const getScmIconNameByBusCode = (businessCode) => {
    if (businessCode.indexOf('purchase') > -1) {
        return '采购管理'; // 'purchase';
    }
    else if (businessCode.indexOf('contracting') > -1) {
        return '施工管理'; // 'contracting';
    }
    else if (businessCode.indexOf('pay') > -1) {
        return '工程款及发票'; // 'pay';
    }
    else if (businessCode.indexOf('ant') > -1) {
        return '金融服务'; // 'ant';
    }
    else if (businessCode.indexOf('quality') > -1) {
        return '质量管理'; // 'quality';
    }
    else if (businessCode.indexOf('safe') > -1) {
        return '安全管理'; // 'safe';
    }
    else if (businessCode.indexOf('fee') > -1) {
        return '费用控制'; // 'fee';
    }
    else if (businessCode.indexOf('construction') > -1) {
        return '施工管理'; // 'construction';
    }
    else if (businessCode.indexOf('schedule') > -1) {
        return '进度管理'; // 'schedule';
    }
    else if (businessCode.indexOf('design') > -1) {
        return '设计管理'; // 'design';
    }
    else if (businessCode.indexOf('scm1010') > -1 ||
        businessCode.indexOf('scm1020') > -1 ||
        businessCode.indexOf('scm1030') > -1) {
        return '采购寻源'; // 'scm1010';
    }
    else if (businessCode.indexOf('scm1040') > -1 ||
        businessCode.indexOf('scm1050') > -1 ||
        businessCode.indexOf('scm2030') > -1 ||
        businessCode.indexOf('scm3010') > -1) {
        return '合同协同'; // 'scm1040';
    }
    else if (businessCode.indexOf('scm1060') > -1 ||
        businessCode.indexOf('scm1070') > -1 ||
        businessCode.indexOf('scm3060') > -1 ||
        businessCode.indexOf('scm3061') > -1 ||
        businessCode.indexOf('scm3020') > -1 ||
        businessCode.indexOf('scm3030') > -1 ||
        businessCode.indexOf('scm3040') > -1 ||
        businessCode.indexOf('scm3021') > -1 ||
        businessCode.indexOf('scm3050') > -1) {
        return '交易协同'; // 'scm1060';
    }
    else if (businessCode.indexOf('scm1080') > -1 ||
        businessCode.indexOf('scm1090') > -1 ||
        businessCode.indexOf('scm2050') > -1) {
        return '协同单位'; // 'scm1080';
    }
    else if (businessCode.indexOf('scm2010') > -1 ||
        businessCode.indexOf('scm2020') > -1) {
        return '物资管理'; // 'scm2010';
    }
    else if (businessCode.indexOf('settle1040') > -1 ||
        businessCode.indexOf('settle1041') > -1 ||
        businessCode.indexOf('scm3041') > -1) {
        return '账单协同'; // 'settle1040';
    }
    else if (businessCode.indexOf('logistic1010') > -1 ||
        businessCode.indexOf('logistic1020') > -1 ||
        businessCode.indexOf('logistic1030') > -1 ||
        businessCode.indexOf('logistic1040') > -1 ||
        businessCode.indexOf('logistic1050') > -1 ||
        businessCode.indexOf('logistic1060') > -1) {
        return '交易协同'; // 'logistic1010';
    }
    else if (businessCode.indexOf('settle1060') > -1 ||
        businessCode.indexOf('settle1070') > -1 ||
        businessCode.indexOf('scm3090') > -1 ||
        businessCode.indexOf('scm3091') > -1 ||
        businessCode.indexOf('settle2010') > -1) {
        return '发票协同'; // 'settle1060';
    }
    else if (businessCode.indexOf('settle1030') > -1 ||
        businessCode.indexOf('settle1050') > -1 ||
        businessCode.indexOf('settle1080') > -1 ||
        businessCode.indexOf('scm3031') > -1) {
        return '结算协同'; // 'settle1030';
    }
    else if (businessCode.indexOf('settle1010') > -1 ||
        businessCode.indexOf('scm3080') > -1 ||
        businessCode.indexOf('scm3081') > -1 ||
        businessCode.indexOf('settle1090') > -1) {
        return '资金往来'; // 'settle1010';
    }
    return businessCode;
};
